const tatCaApp = state => state.tatCaApp;
const danhSachAppPaging = state => state.danhSachAppPaging;
const listApp = state => state.listApp;


export default {
  tatCaApp,
  danhSachAppPaging,
  listApp,
};
